import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textMetadata} from '../../../../../utils/builderMetadata'

export type TextsSettingsParams = {
  aboutSectionTitleText: SettingsParamType.Text
  reservationSectionTitleText: SettingsParamType.Text
  reserveNowButtonText: SettingsParamType.Text
  requestNowButtonText: SettingsParamType.Text
  noReservationText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  aboutSectionTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.section.about-experience'),
    metadata: textMetadata(
      'uou-experiences.experience-details.section.about-experience',
      'Title of the About section',
    ),
  },
  reservationSectionTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.section.reservation'),
    metadata: textMetadata(
      'uou-experiences.experience-details.section.reservation',
      'Title of the reservation section',
    ),
  },
  reserveNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.reserve-now-cta'),
    metadata: textMetadata(
      'uou-experiences.experience-details.reserve-now-cta',
      'Text on the reservation button when reservations are confirmed instantly',
    ),
  },
  requestNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.request-now-cta'),
    metadata: textMetadata(
      'uou-experiences.experience-details.request-now-cta',
      'Text on the reservation button when reservations are requests that need approval',
    ),
  },
  noReservationText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) =>
      t('uou-experiences.experience-details.section.reservation.not-accepting'),
    metadata: textMetadata(
      'uou-experiences.experience-details.section.reservation.not-accepting',
      'Message in the reservation section when the experience is not accepting reservations',
    ),
  },
})
